import angular from 'angular';

module.exports = angular.module('common.filters.url-encode', [])
.filter('urlEncode', function() {
  return function(input) {
    return window.encodeURIComponent(input);
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/url-encode.js
 **/